import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable, Tooltip, Pagination } from 'components';
import { DoctorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission, Permissions } from 'utils';
import { WhiteImage } from 'assets/img';
import { DeleteIcon, StarIcon, StarActiveIcon } from 'assets/icons';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalRate extends React.Component<Props> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		average: 0
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await DoctorService.admin.getRates({
			withoutLoading,
			page: this.state.page,
			user_id: this.props.item?.id
		});
		this.setState({
			data: res.rates.rows,
			last_page: res.rates.count,
			average: res.average
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la calificación?',async () => {
			await DoctorService.admin.deleteRate({
				rate_id: item.id
			});
			this.load(true);
		});
	}
	
	render() {
		return (
			<div id="modal-users-rate">
				<div className="row">
					<div className="col-12">
						<div className="container-profile">
							<img src={ this.props.item?.photo ? (Constants.BASE_STORAGE + this.props.item?.photo) : WhiteImage } />
							<div>
								<h3>{ this.props.item?.name }</h3>
								<div className="container-rate">
									<p>{ this.state.average }</p>
									<div className="container-stars">
										<img src={ this.state.average >= 1 ? StarActiveIcon : StarIcon } />
										<img src={ this.state.average >= 2 ? StarActiveIcon : StarIcon } />
										<img src={ this.state.average >= 3 ? StarActiveIcon : StarIcon } />
										<img src={ this.state.average >= 4 ? StarActiveIcon : StarIcon } />
										<img src={ this.state.average >= 5 ? StarActiveIcon : StarIcon } />
									</div>
								</div>
							</div>
						</div>
						<table>
							<thead>
								<tr>
									<th>Calificación</th>
									<th>Comentario</th>
									<th>Acción</th>
								</tr>
							</thead>
							<tbody>
								{
									this.state.data.map((i: any) =>{
										return (
											<tr>
												<td>
													<div className="container-stars">
														<img src={ i.quantity >= 1 ? StarActiveIcon : StarIcon } />
														<img src={ i.quantity >= 2 ? StarActiveIcon : StarIcon } />
														<img src={ i.quantity >= 3 ? StarActiveIcon : StarIcon } />
														<img src={ i.quantity >= 4 ? StarActiveIcon : StarIcon } />
														<img src={ i.quantity >= 5 ? StarActiveIcon : StarIcon } />
													</div>
												</td>
												<td>
													<p>{ i.comment }</p>
												</td>
												<td>
													{
														checkPermission(Constants.MODULES.REGISTER,'delete',this.props.user) && (
															<Tooltip title="Eliminar">
																<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
																	<img src={ DeleteIcon } />
																</a>
															</Tooltip>
														)
													}
												</td>
											</tr>
										)
									})
								}
								{
									this.state.data.length == 0 && (
										<tr>
											<td colSpan={ 3 }>
												<p className="no-data">No hay calificaciones para este usuario</p>
											</td>
										</tr>
									)
								}
							</tbody>
						</table>

						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					</div>
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-12 text-center">
								<Button type="button" onClick={ () => this.props.onClose() }>
									Cerrar
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalRate);